import Vue from "vue"
import VueRouter from "vue-router"
import NProgress from 'nprogress'

Vue.use(VueRouter);

const routes = [
  {
    name: 'home',
    path: '',
    component: () => import('./Pages/Home')
  },
  {
    name: 'conference',
    path: '/conference/:slug',
    component: () => import('./Pages/Conference')
  },
  {
    name: 'ranking',
    path: '/ranking',
    component: () => import('./Pages/Ranking')
  },
  {
    name: 'profile',
    path: '/profile',
    component: () => import('./Pages/Account')
  },
  {
    name: 'lesson-quiz',
    path: '/lesson/:slug/quiz',
    component: () => import('./Pages/Quizzes'),
    meta: {backToRoute: null}
  },
  {
    name: 'agenda',
    path: '/agenda',
    component: () => import('./Pages/Agenda'),
    meta: {backToRoute: null}
  },

  {
    name: 'subject',
    path: '/subject/:slug',
    component: () => import('./Pages/SubjectProgram'),
  },
  {
    name: 'lesson-video',
    path: '/lesson/:slug/video',
    component: () => import('./Pages/Lesson/VideoView'),
  },
  {
    name: 'users',
    path: '/users',
    component: () => import('./Pages/Users'),
    meta: {backToRoute: 'home'}
  },
  {
    name: 'lesson',
    path: '/lesson/:slug',
    component: () => import('./Pages/Lesson/LessonOverview'),
  },
  {
    name: 'lesson-exercises',
    path: '/lesson/:slug/exercise',
    component: () => import('./Pages/Lesson/ExerciseList')
  },
  {
    name: 'exercise-view',
    path: '/lesson/:lesson_slug/exercise/view/:id',
    component: () => import('./Pages/Lesson/ExerciseView')
  },
  // route for auto suggest
  {
    name: 'exercise',
    path: '/exercise/:id',
    component: () => import('./Pages/Lesson/ExerciseView')
  },
  {
    name: 'questions',
    path: '/questions',
    component: () => import('./Pages/Questions'),
  },
  {
    name: 'question-view',
    path: '/question/:id',
    component: () => import('./Pages/Question'),
  },
  {
    name: 'exam',//test
    path: '/exam/:slug',
    meta: {layout: 'center'},
    component: () => import('./Pages/Exam'),
  },
  {
    name: 'exams',
    path: '/exams',
    component: () => import('./Pages/Annales')
  },
  {
    name: 'course',
    path: '/course/:slug',
    meta: {layout: 'center'},
    component: () => import('./Pages/Lesson/CourseView'),
  },
  {
    name: 'subjects',
    path: '/subjects',
    component: () => import('./Pages/Subjects')
  },
  {
    name: 'live-quiz',
    path: '/live-quiz/:id',
    component: () => import('./Pages/Quizzes')
  },
  {
    name: 'chat',
    path: '/chat',
    component: () => import('./components/Chat/UserChat')
  },
  {
    name: 'subscriptions',
    path: '/subscriptions',
    component: () => import('./Pages/Subscriptions')
  },
  {
    name: 'payments',
    path: '/payments',
    component: () => import('./Pages/Payments')
  }
]

const router = new VueRouter({
  base: '/',
  linkActiveClass: "active",
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})

let timeout = 0

router.beforeEach((to, from, next) => {
  timeout = setTimeout(() => {
    NProgress.start()
  }, 500)
  next()
})
router.afterEach(() => {
  clearTimeout(timeout)
  NProgress.done()
})

export default router
